import { createSlice } from "@reduxjs/toolkit";

type ChatExpandedState = {
  isExpanded: boolean;
};

const initialState: ChatExpandedState = {
  isExpanded: false,
};

export const chatExpanded = createSlice({
  name: "chatExpanded",
  initialState,
  reducers: {
    expandChat: (state) => {
      state.isExpanded = true;
    },
    collapseChat: (state) => {
      state.isExpanded = false;
    },
  },
});

export const { expandChat, collapseChat } = chatExpanded.actions;

export default chatExpanded.reducer;
